// extracted by mini-css-extract-plugin
export default {"container":"EdofSection11_container__5TBjH","LeftSide":"EdofSection11_LeftSide__-wsu1","RightSide":"EdofSection11_RightSide__qnDS-"};